<div class="form">
    <form [formGroup]="form" (ngSubmit)="send()">
        <div class="title">Unsubscribe</div>

        <div *ngFor="let alert of alerts; index as i;">
            <ngb-alert [type]="alert.type" (closed)="closeAlert(i)">{{ alert.msg }}</ngb-alert>
        </div>

        <div class="subtitle">Please select email categories to unsubscribe:</div>

        <div class="checkbox-holder">
            <input type="checkbox" formControlName="marketing" id="marketing"> <label for="marketing">Product discounts and
            promotions</label>
        </div>
        <div class="checkbox-holder">
            <input type="checkbox" formControlName="rounds" id="round"> <label for="round">Golf rounds shared to you by other
            golfers</label>
        </div>

        <button type="submit" [disabled]="!form.valid || isLoading" class="button">
            <span [hidden]="isLoading">Save</span>
            <img src="../../../assets/img/spinner.svg" alt="Loading" [hidden]="!isLoading"/>
        </button>
    </form>
</div>